var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaillift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_265_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.02707 8.47192V12.5182H1.22607",
    stroke: "#214A46",
    strokeWidth: 0.501245,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_265_332",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.07666,
    y: 0.595215,
    width: 10.5056,
    height: 10.3388,
    rx: 0.207579
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.07666,
    y: 0.595215,
    width: 10.5056,
    height: 10.3388,
    rx: 0.207579,
    stroke: "#214A46",
    strokeWidth: 1.00249,
    mask: "url(#path-2-inside-1_265_332)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.4957,
    cy: 11.0174,
    r: 1.5003,
    fill: "white",
    stroke: "#214A46",
    strokeWidth: 0.501245
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52246 9.18799H6.23853M5.52246 10.2621H6.23853",
    stroke: "#214A46",
    strokeWidth: 0.358032
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8892,
    height: 12.1731,
    fill: "white",
    transform: "translate(0.51001 0.595215)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaillift);
export default __webpack_public_path__ + "static/media/Taillift.76272cb8d30ba72d25cabdd3a656c5de.svg";
export { ForwardRef as ReactComponent };